import APPLY from '@/api/module/apply.js';

const applyUpdate = {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    // 获取应用key
    // eslint-disable-next-line
    async queryApplyKey({ commit }, params) {
      try {
        const result = await APPLY.getApplyKey(params);
        return Promise.resolve(result);
      } catch (err) {
        return Promise.reject(err);
      }
    },
    // 新建应用
    // eslint-disable-next-line
    async updateApplyDetail({ commit }, params) {
      try {
        await APPLY.updateApply(params);
        return Promise.resolve('修改成功');
      } catch (err) {
        return Promise.reject(err);
      }
    },
    // 获取应用详情
    // eslint-disable-next-line
    async getApplyDetail({ commit }, params) {
      try {
        const result = await APPLY.getPayApply(params);
        return Promise.resolve(result);
      } catch (err) {
        return Promise.reject(err);
      }
    },
  },
  getters: {},
};

export default applyUpdate;
